export const DEVICE_TAG = 'GWP';
export const DEVICE_VERSION_CODE = '123';
export const DEVICE_VERSION_NAME = 'GWP';
